import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, computed, signal } from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { Subject, filter, takeUntil } from 'rxjs';
import { AppBreadcrumbItem, ROUTE_BREADCRUMBS } from '../../core/config/navigation.config';
import { DatePicker } from "primeng/datepicker";
import { Select } from "primeng/select";
import { FormsModule } from '@angular/forms';
import { TicketDashboardHeaderService } from '../../core/services/ticket-dashboard-header.service';
import { AuditLogHeaderService } from '../../core/services/audit-log-header.service';
import { UserListHeaderService } from '../../core/services/user-list-header.service';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [CommonModule, RouterLink, DatePicker, Select,FormsModule],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss',
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
  protected selectedRegion = 'all';
  protected selectedDate = new Date(2025, 4, 20);
  protected lastRefreshedLabel = '10:30 AM';

  protected readonly regionOptions = [
    { label: 'All Regions', value: 'all' },
    { label: 'NRPC', value: 'nrpc' },
    { label: 'WRPC', value: 'wrpc' },
    { label: 'SRPC', value: 'srpc' },
    { label: 'ERPC', value: 'erpc' },
    { label: 'NERPC', value: 'nerpc' },
  ];


  protected readonly breadcrumbs = signal<AppBreadcrumbItem[]>([]);
  protected readonly showDashboardFilters = computed(() => this.breadcrumbs().some((item) => item.filter));
  protected readonly showRaiseTicketAction = computed(() => this.breadcrumbs().some((item) => item.label === 'Raise Ticket'));
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly router: Router,
    protected readonly ticketDashboardHeader: TicketDashboardHeaderService,
    protected readonly auditLogHeader: AuditLogHeaderService,
    protected readonly userListHeader: UserListHeaderService,
  ) {}

  ngOnInit(): void {
    this.updateBreadcrumbs(this.router.url);
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      takeUntil(this.destroy$),
    ).subscribe((event) => this.updateBreadcrumbs(event.urlAfterRedirects));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateBreadcrumbs(url: string): void {
    const routeKey = this.resolveRouteKey(url);
    this.breadcrumbs.set(routeKey ? ROUTE_BREADCRUMBS[routeKey] : []);
  }

  private resolveRouteKey(url: string): string | undefined {
    const cleanUrl = url.split('?')[0].split('#')[0];
    if (cleanUrl.startsWith('/user-management/view/')) {
      return '/user-management/view';
    }
    if (cleanUrl.startsWith('/user-management/edit/')) {
      return '/user-management/edit';
    }

    return ROUTE_BREADCRUMBS[cleanUrl] ? cleanUrl : undefined;
  }
   protected refreshDashboard(): void {
    this.lastRefreshedLabel = new Date().toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  }
}
